module.exports = __webpack_public_path__ + "img/exhibit-icon.315eb135.png";